"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPackages = buildPackages;
const apply_transporter_1 = require("../apply-transporter");
const calculate_logistic_cost_1 = require("../calculate-logistic-cost");
const split_into_logistic_order_1 = require("../split-into-logistic-order");
function buildPackages(lineItemPackagingCriteria) {
    const logisticOrders = getLogisticOrderQueries((0, split_into_logistic_order_1.splitIntoLogisticOrder)(lineItemPackagingCriteria), lineItemPackagingCriteria);
    return (0, calculate_logistic_cost_1.calculateLogisticCost)((0, apply_transporter_1.applyTransporterToLogisticOrderQueries)(logisticOrders));
}
function getLogisticOrderQueries(logisticOrders, lineItemPackagingCriteria) {
    return logisticOrders.map(({ lines, ...logisticSplit }) => {
        return {
            ...logisticSplit,
            lines: lines.map(line => {
                const lineItemPackagingCriterion = lineItemPackagingCriteria.find(criterion => criterion.lineId === line.lineId);
                if (!lineItemPackagingCriterion)
                    throw new Error('Implementation error');
                return {
                    lineId: line.lineId,
                    selectedLogisticOffer: line.selectedLogisticOffer,
                    linePrice: lineItemPackagingCriterion.linePrice,
                    weightInGrams: lineItemPackagingCriterion.weightInGrams,
                    dimensions: lineItemPackagingCriterion.dimensions,
                    quantity: lineItemPackagingCriterion.quantity
                };
            })
        };
    });
}
